module.exports = __webpack_public_path__ + "static/img/watch.36ef6e27.png";